import{d as r}from"./chunk-UHFZTYDX.js";import{q as i}from"./chunk-WFWW2WKK.js";import{b as o}from"./chunk-S2WA2NOC.js";import{m as t}from"./chunk-HBP5N4FR.js";t();i();function p(e){return r(n=>o(n,e))}export{p as a};
//# sourceMappingURL=chunk-QZFCRWGC.js.map
